import { ConfirmOptions, useConfirm } from 'material-ui-confirm';

export function useDialogConfirm() {
  const confirm = useConfirm();

  const dialogConfirm = async (options?: ConfirmOptions) => {
    try {
      await confirm(options);
      return 'confirmed';
    } catch {
      return 'canceled';
    }
  };

  return dialogConfirm;
}
